import { useState, useEffect } from 'react';
import { C, t } from './dashboardConstants';
import { IcoBookmark, IcoEye } from './DashboardIcons';
import { getMyTalentStats, getMyTalentViews } from '../../../../api';

function DonutChart({ segments }) {
  const r = 31;
  const circ = 2 * Math.PI * r;
  let acc = 0;
  return (
    <svg width="78" height="78" viewBox="0 0 78 78" style={{ flexShrink: 0, aspectRatio: '1 / 1' }}>
      <circle cx="39" cy="39" r={r} fill="none" stroke={C.g200} strokeWidth="8" />
      {segments.map((segment, index) => {
        const pct = Math.max(0.05, Math.min(0.95, segment.pct));
        const arc = circ * pct;
        const dashOffset = -acc * circ;
        acc += pct;
        return (
          <circle
            key={`${segment.color}-${index}`}
            cx="39"
            cy="39"
            r={r}
            fill="none"
            stroke={segment.color}
            strokeWidth="8"
            strokeDasharray={`${arc} ${circ}`}
            strokeDashoffset={dashOffset}
            transform="rotate(-90 39 39)"
            strokeLinecap="round"
          />
        );
      })}
    </svg>
  );
}

function StatsCard() {
  const [stats, setStats] = useState(null);
  const [views, setViews] = useState(null);

  useEffect(() => {
    getMyTalentStats().then(setStats).catch(() => {});
    getMyTalentViews().then(setViews).catch(() => {});
  }, []);

  const viewCount = views?.totalViews ?? 0;
  const bookmarkCount = stats?.bookmarkCount ?? 0;
  const producerViewCount = views?.producerViewCount ?? views?.producerViews ?? 0;
  const talentViewCount = views?.talentViewCount ?? views?.talentViews ?? 0;
  const breakdownTotal = producerViewCount + talentViewCount;
  const viewSegments = breakdownTotal > 0
    ? [
        { color: C.purple, pct: producerViewCount / breakdownTotal },
        { color: C.blue, pct: talentViewCount / breakdownTotal },
      ].filter((segment) => segment.pct > 0)
    : [{ color: C.purple, pct: 1 }];

  return (
    <div style={{ background: C.white, border: `1px solid ${C.g200}`, borderRadius: '20px', padding: '22px 50px', boxShadow: C.shadow, display: 'flex', alignItems: 'stretch', overflow: 'hidden' }}>
      {/* 프로필 저장횟수 */}
      <div style={{ flex: 1.5, padding: '0 24px 0 0', display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}><IcoBookmark/><span style={t('13px', 500, C.sub)}>프로필 저장횟수</span></div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '78px', gap: '6px' }}>
          <span style={{ ...t('36px', 700, C.bk), lineHeight: 1 }}>{bookmarkCount}</span>
          <span style={t('14px', 400, C.sub)}>총 저장 수</span>
        </div>
      </div>

      {/* 프로필 조회수 */}
      <div style={{ flex: 1.5, padding: '0 24px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}><IcoEye/><span style={t('13px', 500, C.sub)}>프로필 조회수</span></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', minHeight: '78px' }}>
          <DonutChart segments={viewSegments} />
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '78px', gap: '12px', flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <span style={{ ...t('36px', 700, C.bk), lineHeight: 1 }}>{viewCount}</span>
              <span style={t('14px', 400, C.sub)}>총 조회 수</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: C.purple }} />
                <span style={t('12px', 400, C.sub)}>제작사</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: C.blue }} />
                <span style={t('12px', 400, C.sub)}>배우</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatsCard;
